export const getQueryParams = (searchParam, paramName) => {
    const queryParamsString = searchParam.substring(1)
    const searchParams = new URLSearchParams(queryParamsString)

    return searchParams.get(paramName)
}
